import { canRead, canWrite } from '../access/rbacAccess'

export const DELIVERIES = {
  LIST: 'ejecuta.deliveries',
  ASSIGN: 'planifica.add_deliveries_user'
}

export const canViewDeliveries = () => canRead(DELIVERIES.LIST)

export const canManageDeliveries = () => canWrite(DELIVERIES.LIST)

export const canViewAssignDeliveries = () => canRead(DELIVERIES.ASSIGN)

export const canManageAssignDeliveries = () => canWrite(DELIVERIES.ASSIGN)
